import React, { forwardRef, useRef, useState } from 'react';

import { Box, ScrollArea, ScrollAreaProps } from '@mantine/core';
import { VirtuosoGrid } from 'react-virtuoso';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomItem = ({ children, ...props }: any) => (
  <Box
    {...props}
    style={{
      flex: '0 0 auto',
      boxSizing: 'border-box'
    }}>
    {children}
  </Box>
);

CustomItem.displayName = 'CustomItem';

const CustomList = forwardRef<HTMLDivElement, { style?: React.CSSProperties; children?: React.ReactNode }>(
  ({ style, children, ...props }, ref) => (
    <Box
      ref={ref}
      {...props}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        ...style
      }}>
      {children}
    </Box>
  )
);

CustomList.displayName = 'CustomList';

interface VirtualGridScrollAreaProps extends ScrollAreaProps {
  items: Array<React.ReactNode>;
  loadingItem?: React.ReactNode;
}

export function VirtualGridScrollArea({ items, loadingItem, ...scrollAreaProps }: VirtualGridScrollAreaProps) {
  const [isScrolling, setIsScrolling] = useState(false);
  const scrollAreaRef = useRef<HTMLDivElement>(null);

  const itemsCopy = [...items];
  return (
    <ScrollArea {...scrollAreaProps} viewportRef={scrollAreaRef}>
      <VirtuosoGrid
        useWindowScroll={false}
        totalCount={itemsCopy.length}
        data={itemsCopy}
        components={{
          Item: CustomItem,
          List: CustomList
        }}
        isScrolling={(value) => setIsScrolling(value)}
        customScrollParent={scrollAreaRef.current ? scrollAreaRef.current : undefined}
        itemContent={(index, item) => {
          return <Box key={index}>{isScrolling && loadingItem ? loadingItem : item}</Box>;
        }}
      />
    </ScrollArea>
  );
}
